"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

var _bs = require("react-icons/bs");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Input = function Input(_ref) {
  var backgroundColor = _ref.backgroundColor,
      border = _ref.border,
      className = _ref.className,
      color = _ref.color,
      disabled = _ref.disabled,
      errors = _ref.errors,
      fonstSizeIcon = _ref.fonstSizeIcon,
      handleClickOnIcon = _ref.handleClickOnIcon,
      disabledIcon = _ref.disabledIcon,
      hasChanged = _ref.hasChanged,
      helperText = _ref.helperText,
      icon = _ref.icon,
      isDecimal = _ref.isDecimal,
      isInvalid = _ref.isInvalid,
      label = _ref.label,
      max = _ref.max,
      maxLength = _ref.maxLength,
      min = _ref.min,
      name = _ref.name,
      oldValue = _ref.oldValue,
      onBlur = _ref.onBlur,
      _onChange = _ref.onChange,
      onSearchFunction = _ref.onSearchFunction,
      placeholder = _ref.placeholder,
      showIcon = _ref.showIcon,
      type = _ref.type,
      value = _ref.value;
  var borderColor = isInvalid ? 'group-input-search border-search' : 'group-input-search';

  var popover = /*#__PURE__*/_react.default.createElement(_reactBootstrap.Popover, {
    id: "popover-".concat(name)
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Popover.Header, {
    as: "h4"
  }, label), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Popover.Body, {
    style: {
      padding: ' 0.25rem 0.5rem'
    }
  }, helperText && helperText.split('[BR]').map(function (text, idx) {
    return /*#__PURE__*/_react.default.createElement("p", {
      key: "text-".concat(idx * 10),
      style: {
        margin: 5
      }
    }, text);
  })));

  var renderTooltip = function renderTooltip(props) {
    return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tooltip, _extends({}, props, {
      className: "customTooltip"
    }), oldValue);
  };

  var validTypeForm = function validTypeForm(e) {
    var expresionNumber = isDecimal ? /^[0-9\b.[0-9\b]+$/ : /^[0-9\b]+$/;

    if (expresionNumber.test(e.target.value) && e.target.value) {
      _onChange(e);
    }

    if (!e.target.value && !expresionNumber.test(e.target.value)) {
      _onChange({
        target: {
          name: name,
          value: ''
        }
      });
    }
  };

  var blockedInvalidCharacters = function blockedInvalidCharacters(e) {
    var blockers = isDecimal ? ['e', 'E', '+', '-', '{', '}'] : ['e', 'E', '+', '-', '{', '}', '.', ','];
    return blockers.includes(e.key) && e.preventDefault();
  };

  var renderInputForm = function renderInputForm() {
    return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
      type: type,
      autoComplete: "off",
      disabled: disabled,
      placeholder: placeholder,
      value: value,
      name: name,
      isInvalid: isInvalid,
      onChange: function onChange(e) {
        type === 'number' ? validTypeForm(e) : _onChange(e);
      },
      maxLength: maxLength,
      max: max,
      min: min,
      className: "".concat(hasChanged ? 'blueBackgorund' : '', " ").concat(color, " ").concat(border, " ").concat(backgroundColor),
      onKeyDown: type === 'number' ? function (e) {
        return blockedInvalidCharacters(e);
      } : function () {},
      onBlur: onBlur
    });
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "styleInput ".concat(className)
  }, label && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, label), /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    hasValidation: true,
    className: "\n        container-input \n        ".concat(icon ? 'container-right-icon' : '', " \n        ").concat(isInvalid ? 'invalid-input' : '')
  }, hasChanged ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.OverlayTrigger, {
    placement: "top-start",
    overlay: renderTooltip
  }, renderInputForm()) : renderInputForm(), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control.Feedback, {
    type: "invalid"
  }, errors), showIcon && !disabled && /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "button-search",
    onClick: onSearchFunction
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup.Text, {
    className: borderColor
  }, /*#__PURE__*/_react.default.createElement(_bs.BsSearch, null))), icon && !showIcon && /*#__PURE__*/_react.default.createElement("button", {
    className: "right-icon ".concat(color, " ").concat(backgroundColor),
    disabled: disabledIcon,
    onClick: handleClickOnIcon,
    style: {
      fontSize: fonstSizeIcon
    }
  }, icon)), helperText && /*#__PURE__*/_react.default.createElement("div", {
    className: "overlay"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.OverlayTrigger, {
    trigger: "click",
    placement: "bottom",
    overlay: popover,
    rootClose: true
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    variant: "link",
    style: {
      padding: '0.1rem'
    },
    size: "sm"
  }, /*#__PURE__*/_react.default.createElement(_bs.BsQuestionCircle, null)))));
};

Input.propTypes = {
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.object]),
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  disabledIcon: _propTypes.default.bool,
  errors: _propTypes.default.string,
  fonstSizeIcon: _propTypes.default.string,
  handleClickOnIcon: _propTypes.default.func,
  hasChanged: _propTypes.default.bool,
  helperText: _propTypes.default.string,
  icon: _propTypes.default.element,
  isDecimal: _propTypes.default.bool,
  isInvalid: _propTypes.default.bool,
  label: _propTypes.default.string,
  max: _propTypes.default.number,
  maxLength: _propTypes.default.number,
  min: _propTypes.default.number,
  name: _propTypes.default.string.isRequired,
  oldValue: _propTypes.default.string,
  onBlur: _propTypes.default.func,
  onChange: _propTypes.default.func,
  placeholder: _propTypes.default.string,
  showIcon: _propTypes.default.bool,
  type: _propTypes.default.string.isRequired,
  color: _propTypes.default.oneOf(['default', 'colorBlue', 'colorGreen', 'colorBlack', 'colorRed', 'colorWhite', 'colorGrey']),
  backgroundColor: _propTypes.default.oneOf(['default', 'backgroundBlue', 'backgroundGreen', 'backgroundGrey']),
  border: _propTypes.default.oneOf(['default', 'transparent'])
};
Input.defaultProps = {
  backgroundColor: 'default',
  border: 'default',
  className: '',
  color: 'default',
  disabled: false,
  disabledIcon: false,
  errors: '',
  fonstSizeIcon: '16px',
  handleClickOnIcon: function handleClickOnIcon() {},
  hasChanged: false,
  helperText: null,
  icon: null,
  isDecimal: true,
  isInvalid: false,
  label: '',
  max: null,
  maxLength: null,
  min: null,
  oldValue: '',
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  placeholder: '',
  showIcon: false
};
var _default = Input;
exports.default = _default;